(function(){
  'use strict';

  angular
    .module('app')
    .filter('imgUrl', imgUrlFilter);

  function imgUrlFilter(apiConfig) {
    return function(input) {
      return `${apiConfig.urlImages}/imagens_${apiConfig.hashUpload}/${input}`;
    }
  }

})();
